import React, { useState } from "react";
import EditIcon from '../assets/img/edit.svg';
import CancelIcon from '../assets/img/cancel.svg';
import Check2Icon from '../assets/img/check2.svg';
import { confirmAlert } from 'react-confirm-alert';
import '../assets/css/react-confirm-alert.css'

function EditableInput(props) {
    const [value, setValue] = useState(props.value);
    const [inEdit, setInEdit] = useState(false);

    const saveValue = () => {
        if ((props.minLength && props.minLength > 0 && (!value || value.trim() === "")) || (props.minLength && value.length < props.minLength)) {
            confirmAlert({
                title: 'Update area name',
                message: "Name must not be empty.",
                buttons: [
                    {
                        label: 'Ok',
                        onClick: () => { return }
                    }
                ]
            });
            return;
        }
        props.save(value);
        setInEdit(false);
    }

    return (
        <>
            {!inEdit &&
                <React.Fragment>
                    <span>{value}</span>
                    <img
                        src={EditIcon}
                        alt="Edit area name"
                        style={{ height: "1em", marginLeft: "4px", cursor: "pointer" }}
                        onClick={() => { setInEdit(true) }}
                    />
                </React.Fragment>
            }
            {inEdit &&
                <React.Fragment>
                    <input value={value} onChange={e => setValue(e.target.value)}></input>
                    <img
                        src={Check2Icon}
                        alt="Save"
                        style={{ height: "1.4em", marginLeft: "4px", cursor: "pointer" }}
                        onClick={saveValue}
                    />
                    <img
                        src={CancelIcon}
                        alt="Cancel"
                        style={{ height: "1.4em", marginLeft: "4px", cursor: "pointer" }}
                        onClick={() => {
                            setInEdit(false);
                            setValue(props.value);
                        }}
                    />
                </React.Fragment>
            }
        </>
    );
};

export default EditableInput;